import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PartyType  {
    _originalTypeClassName = "zERP.BO.PartyType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PartyType.translate = translateService;
}
this.Id = null;
this.VatNumber = null;
this.Branch = null;
this.Name = null;
this.Country = null;
this.GetCountry = null;
this.CountryStr = null;
this.ERPAA = null;
this.ERPDocID = null;
this.IssuerCounterpart = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
VatNumber:any;
Branch:any;
Name:any;
Country:any;
GetCountry:any;
CountryStr:any;
ERPAA:any;
ERPDocID:any;
IssuerCounterpart:any;
Address:any;
ERPInvoiceCategory:any;
ERPInvoiceType:any;
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}
static setERPInvoiceCategory = ($this, value) => {
var oldValue = $this.ERPInvoiceCategory;
$this.ERPInvoiceCategory = value;
if (value != null) {
}
}
static setERPInvoiceType = ($this, value) => {
var oldValue = $this.ERPInvoiceType;
$this.ERPInvoiceType = value;
if (value != null) {
}
}

static CountryStringToEnum($this: any, country: any): any{let ser = new CLMS.Framework.Utilities.Serializer<any>();
let myenum = ser.ParseEnum(country);
return myenum;
}
static CreateFromBusinessEntity(businessEntity: any): any{let partyType = new Domain.PartyType();
partyType.VatNumber = businessEntity?.TaxNumber;
partyType.Branch = businessEntity?.BranchOwner?.Id;
partyType.Name = businessEntity?.Name;
partyType.Country = Domain.Country.ToCountryType(businessEntity?.Country);
return partyType;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}